import React from "react";
import Navigation from "../utils/Navigation";
import "../../css/lizing/lizingFinance.css";
import "../../css/lizing/leasing-refresh.css";
import '../../css/lizing/rosagro.css';
import {findElementByLink} from "../utils/siteStructure";
import siteStructure from "../siteStructure.json";
import {Link, useLocation} from "react-router-dom";
import SeoHelmet from "../utils/seo";
import {useTheme} from "../header/Header";
import {LeasingEquipment} from "./LizingRosagro";

// Картинки теперь в public → строковые URL.
const Guarantee = "/images/lizing/IconGuarantee.webp";
const Gazprom   = "/images/lizing/gazprom.webp";
const Lukoil    = "/images/lizing/lukoil.webp";
const Rosneft   = "/images/lizing/rosneft.webp";
const Sibur     = "/images/lizing/sibur.webp";
const Taneco    = "/images/lizing/taneco.webp";
const Tatneft   = "/images/lizing/tatneft.webp";

const ROSAGRO_LEASING = [
    {
        url: '/lizing/lizing_rosagro',
        title: 'Лизинг от АО «Росагролизинг»',
        image: 'lizing/ros.webp'
    }
];

export default function LizingFinance(){

    const location = useLocation();
    const data = findElementByLink(siteStructure, location.pathname)
    const seo = data.seo? data.seo : {title:"", description:"", keywords:"", changefreq: 'yearly', priority: 0.4}
    const { theme } = useTheme()


    return (
        <>
            <Navigation/>
            <SeoHelmet
                title={seo.title}
                description={seo.description}
            />
            <div className={`overlay`}>
                <div className={`complexBack ${theme}`}> </div>
                <div className={`lizingFinance-container leasing-page ${theme}`}>
                    <section className="leasing-hero">
                        <div className="leasing-hero-copy">
                            <span className="leasing-eyebrow">Сеспель-Финанс · Лизинг от производителя</span>
                            <h1>Ваша техника.<br/>Новые возможности.</h1>
                            <p>Подберите полуприцеп для своего бизнеса. Мы поможем с комплектацией, оформлением и финансированием покупки.</p>
                            <div className="leasing-actions">
                                <a className="leasing-button" href="#leasing-programs">Сравнить программы <span aria-hidden="true">↗</span></a>
                                <a className="leasing-contact" href="tel:+79379427106">Обсудить со специалистом ↗</a>
                            </div>
                        </div>
                        <div className="leasing-hero-image">
                            <img src="/images/lizing/lizingSespelFinance.webp" alt="Техника Сеспель для приобретения в лизинг"/>
                            <span>Напрямую от завода «Сеспель»</span>
                        </div>
                    </section>
                    <div className="leasing-section-heading" id="leasing-programs">
                        <span className="leasing-eyebrow">01 / Финансирование</span>
                        <h2>Выберите вашу программу</h2>
                        <p>Сравните удорожание, первоначальный взнос и срок лизинга.</p>
                    </div>
                    <div className={`lizingProgramsWrapper ${theme}`}>
                        <LizingProgram per={"7,2"} prepaid={"49"} duration={"1 год"}/>
                        <LizingProgram per={"7,9"} prepaid={"40"} duration={"2 года"}/>
                        <LizingProgram per={"10,9"} prepaid={"30"} duration={"3 года"}/>
                    </div>
                    <div className={"lizingFinanceFeatures"}>
                        <h1>ПРЕИМУЩЕСТВА КОМПАНИИ</h1>

                        <div className={"lizingFinanceFeaturesInfo"}>
                            <div>
                                <h1>О группе компаний "Сеспель"</h1>
                                <p>Завод «Сеспель» работает с 1999 года
                                    и за эти годы успешной работы реализовал
                                    более 5500 полуприцепов и автоцистерн
                                    для компаний по всей России и странам СНГ.</p>
                            </div>
                            <div className={`lizingFinanceFeaturesInfoBlock ${theme}`}>
                                <div>
                                    <h1>МИНИМАЛЬНЫЙ</h1>
                                    <p>пакет документов</p>
                                </div>
                                <div>
                                    <h1>ЗА 1 ДЕНЬ</h1>
                                    <p>Получите решение о выдаче</p>
                                </div>
                            </div>
                            <div className={`lizingFinanceFeaturesInfoBlock ${theme}`}>
                                <div>
                                    <h1>5%</h1>
                                    <p>первоначальный взнос</p>
                                </div>
                                <div>
                                    <h1>БЕЗ НАЦЕНКИ</h1>
                                    <p>По заводским ценам</p>
                                </div>
                            </div>
                        </div>
                        <p>
                            ООО ЛК "Сеспель-финанс" – это
                            дочерняя компания завода-изготовителя
                            ЗАО «Сеспель». Наша цель – оказание
                            помощи в выборе, оформлении и
                            финансировании покупки полуприцепов
                            «Сеспель» для организаций, работающих
                            в сфере перевозок, строительства,
                            сельского хозяйства, а также в нефтегазовой,
                            химической, пищевой и перерабатывающей
                            промышленности. Лизинг от «Сеспель-Финанс»
                            поможет вам приобрести технику простым,
                            оперативным и удобным способом, оставляя
                            вам больше времени для ведения бизнеса и
                            достижения целей вашей компании.
                            Мы консультируем, подбираем технику,
                            принимаем решение по лизингу за 1 день,
                            а также рассчитываем стоимость лизинга бесплатно!
                        </p>
                    </div>
                    <div className={"lizingFinancePartners"}>
                        <div>
                            <h1>РАБОТАЕМ С КРУПНЕЙШИМИ ИГРОКАМИ НЕФТЕГАЗОВОЙ ОТРАСЛИ</h1>
                            <p>После аванса в 5% мы изготавливаем полуприцеп в срок до 30 дней
                                и сообщаем вам о его готовности.</p>
                            <p>Вы получаете полуприцеп и сразу начинаете зарабатывать, оплачивая лизинговые платежи.</p>
                        </div>
                        <div>
                            <img src={Gazprom} alt="no-img"/>
                            <img src={Tatneft} alt="no-img"/>
                            <img src={Lukoil} alt="no-img"/>
                            <img src={Rosneft} alt="no-img"/>
                            <img src={Taneco} alt="no-img"/>
                            <img src={Sibur} alt="no-img"/>
                        </div>
                    </div>

                    <h1 className={"lizingFinanceAdvantagesH3"}>ДОПОЛНИТЕЛЬНЫЕ ПРЕИМУЩЕСТВА ОТ ООО ЛК "СЕСПЕЛЬ-ФИНАНС"</h1>
                    <div className={"lizingFinanceAdvantages"}>
                        <LizingAdvatageBlock headText1={"Решение"} headText2={"за 24 часа"} head={true}
                                             bodyText={`Решение по лизингу принимается за 1 день`}/>

                        <LizingAdvatageBlock headText1={"Вносите 5% и"} headText2={"забираете технику"} head={false}
                                             bodyText={
                                                 `Первоначальный взнос – 5%. Забрать технику можно сразу после 
                                             внесения 5% суммы, а не 70%, как при обычной покупке.`}
                        />

                        <LizingAdvatageBlock headText1={"Минимум"} headText2={"документов"} head={true}
                                             bodyText={
                                                 `Минимальный пакет документов вследствие того,
                                             что ООО ЛК "Сеспель-финанс"– это лизинговая компания ЗАО "Сеспель".`}/>

                        <LizingAdvatageBlock headText1={"Без"} headText2={"залога"} head={false}
                                             bodyText={
                                                 `В отличие от банковского кредита, в лизинге 
                                             от ООО ЛК "Сеспель-финанс" вы не вносите никакого
                                              дополнительного залога`}
                        />

                        <LizingAdvatageBlock headText1={"Меньше платеж"} headText2={"и каско до 5 лет"} head={false} up={false}
                                             bodyText={
                                                 `Лизинг на пять лет позволяет уменьшить
                                              ежемесячный платежи получить 5 лет КАСКО,
                                              учтенных в лизинговых платежах.`}
                        />

                        <LizingAdvatageBlock headText1={"Принцип"} headText2={"одного окна"} head={true} up={false}
                                             bodyText={
                                                 `Действует "принцип одного окна".
                                             Все технические вопросы, связанныес
                                              производством и вопросы оформления
                                               купли-продажи решает сама лизинговая компания`}
                        />

                        <LizingAdvatageBlock headText1={"Техника платит"} headText2={"сама за себя"} head={false} up={false}
                                             bodyText={
                                                 `Вы вносите лизинговые платежи по
                                              договору равными суммами в течение
                                               5 лет. Оплачивайте полуприцеп с
                                                заработанных им же денег.`}
                        />

                        <LizingAdvatageBlock headText1={"Без скрытых"} headText2={"комиссий"} head={true} up={false}
                                             bodyText={
                                                 `Наша лизинговая программа отличается
                                              абсолютной прозрачностью. Вы сразу
                                               получаете полную информацию обо всех
                                                условиях лизинга и подробный график платежей`}
                        />
                    </div>

                    <h1 className={"lizingFinanceAdvantagesH3"}>СЭКОНОМЬТЕ ДО 500 000 РУБ.</h1>
                    <p>Лизинговые платежи в полном объеме уменьшают налогооблагаемую прибыль.</p>
                    <p>НДС с суммы лизинговых платежей в полном объеме принимаются к вычету.</p>
                    <p> По окончании срока действия лизинга имущество переходит в вашу собственность по минимальной стоимости (1000 рублей).</p>

                    <h1 className={"lizingFinanceAdvantagesH3"}>КАК МЫ РАБОТАЕМ</h1>
                    <div className={`lizingFinanceWorks ${theme}`}>
                        <div className={`lizingFinanceWorksDay`}>
                            <div>
                                <span>1</span>
                                <span>день</span>
                            </div>
                        </div>
                        <div className={"lizingFinanceWorksSteps"}>
                            <LizingFinanceStep step={1} text={"Мы подбираем вам подходящий полуприцеп (бензовоз или битумовоз) и его комплектацию"}/>
                            <LizingFinanceStep step={2} text={"Вы представляете пакет всего из трех документов"}/>
                            <LizingFinanceStep step={3} text={"Получаете решение по лизингу всего за 1 день"}/>
                            <div> </div>
                            <LizingFinanceStep step={4} text={"При положительном решении присылаете оставшиесся документы"}/>
                            <LizingFinanceStep step={5} text={"Заключаем с вами договор лизинга и обговариваем условия получения техники."}/>
                        </div>
                    </div>
                    <p>После аванса в 5% мы изготавливаем полуприцеп
                        в срок до 30 дней и сообщаем вам о его готовности.
                        Вы получаете полуприцеп и сразу начинаете зарабатывать,
                        оплачивая лизинговые платежи.</p>
                    <h1>ГАРАНТИЯ БЕЗ ОГРАНИЧЕНИЯ ПРОБЕГА</h1>
                    <div className={`lizingFinanceGuarantee ${theme}`}>
                        <div>
                            <img src={Guarantee} alt="no-img"/>
                            <p>Вы получаете 5 лет гарантии на оси
                                от производителя и "Сеспель".</p>
                        </div>
                        <div>
                            <img src={Guarantee} alt="no-img"/>
                            <p>Вы получаете 1 год гарантии на герметичность
                                цистерны от протечек от ЗАО "Сеспель".</p>
                        </div>
                        <div>
                            <img src={Guarantee} alt="no-img"/>
                            <p>Вы получаете 5 лет страхования по КАСКО,
                                которое уже включено в лизинговые платежи.</p>
                        </div>
                    </div>
                    <div className={"lizingFinanceTerms"}>
                        <div>
                            <h1>УСЛОВИЯ ОПЛАТЫ И ДОСТАВКИ</h1>
                            <p>«Сеспель» – крупнейшее предприятие России по производству полуприцепов.</p>
                            <div className={"lizingFinanceNumber"}>
                                <span>Звоните!</span>
                                <a className="leasing-phone" href="tel:+79379427106">+7 (937) 942-71-06</a>
                                <p>Наш ведущий специалист проконсультирует вас по всем вопросам.</p>
                            </div>
                        </div>
                        <div className={`lizingFinanceTermsRightColumn ${theme}`}>
                            <div>
                                <div>
                                    <p>УСЛОВИЯ</p>
                                    <p>ОПЛАТЫ</p>
                                </div>
                                <div>
                                    <p>
                                        Оплата производится безналичным перечислением
                                        В лизинг (на 5 лет, 5%-первоначальный взнос)
                                    </p>
                                </div>
                            </div>

                            <div>
                                <div>
                                    <p>УСЛОВИЯ</p>
                                    <p>ДОСТАВКИ</p>
                                </div>
                                <div>
                                    <p>
                                        Самовывоз с завода вашим тягачом
                                        (завод находится в селе Москакасы
                                        Моргаушского района Чувашии – на трассе М7).
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <LeasingEquipment
                        items={ROSAGRO_LEASING}
                        theme={theme}
                        id="rosagro-program"
                        eyebrow="Альтернативная программа"
                        title="Лизинг от АО «Росагролизинг»"
                        description="Федеральная программа для АПК: первый взнос от 0%, срок до 7 лет, решение по заявке за 1 день."
                    />

                    <Link className="rosagro-back" to="/lizing">← Все программы лизинга</Link>
                </div>
            </div>
        </>
    )
}

function LizingProgram({per, prepaid, duration}){

    const { theme } = useTheme()

    return (
        <div>
            <div className={`lizingProgramText ${theme}`}>
                <div>
                    <span className="number_art">{per}</span>
                    <span className="percent_art">%</span>
                    <br/>
                    <span>удорожания</span>
                </div>
                <ul>
                    <li>
                        <span>Аванс: </span>
                        <span>{prepaid}%</span>
                    </li>
                    <li>
                        <span>Срок: </span>
                        <span>{duration}</span>
                    </li>
                </ul>
            </div>
        </div>
    )
}

function LizingAdvatageBlock({headText1, headText2, bodyText, up=true, head=false}){

    return (
        <div>

            <div className={`${head? "lizingFinanceAdvantagesHead" : "lizingFinanceAdvantagesNoHead"} ${up? "" : "lizingFinanceAdvantagesBottom"}`}>
                <p>{headText1}</p>
                <p>{headText2}</p>
            </div>


            <div className={`lizingFinanceAdvantagesBody`}>
                <p>{bodyText}</p>
            </div>
        </div>
    )

}

function LizingFinanceStep({step, text}){

    return (
        <div>
            <div>
                <span>{step}</span>
                <span>шаг</span>
                <p>{text}</p>
            </div>
        </div>
    )
}
